import React  from 'react';
import Iframe from 'react-iframe';


const Home = () => {
            
  return (
    <div className='container-fluid mt-4'>
       
    <Iframe url="./annouceth.htm"
                 position="absolute"
                 width="100%"                
                 height="100%"
                
     />
    
    </div>
  )
}

export default Home


